<cx-generic-link
  *ngIf="data$ | async as data"
  [url]="data.localizedUrl ? data.localizedUrl : data.url"
  [style]="data.styleAttributes"
  [target]="getTarget(data)"
  >{{ data.linkName }}
</cx-generic-link>
